import { DOCUSIGN } from '../types';

const initialState = {
  docuSignDropdown: false,
};

const docuSignReducer = (state = initialState, action) => {
  switch (action.type) {
    case DOCUSIGN.SWITCH_DOCUSIGN_DROPDOWN:
      return {
        docuSignDropdown: !state.docuSignDropdown,
      };
    case DOCUSIGN.CLOSE_DOCUSIGN_DROPDOWN:
      return {
        docuSignDropdown: false,
      };

    default:
      return state;
  }
};

export default docuSignReducer;
